import { useState } from "react";
import logo from "../assets/brand/logo.png";
import { useSearchParams } from "react-router-dom";
import { handleResetPassword } from "../services/emailActions";
import PageNotFound from "./page_not_found";
import { signOut } from "firebase/auth";
import { fAuth } from "../config/firebase";
import { updateDoc } from "firebase/firestore";
import { getKeysDoc } from "../utils/firestoreHelpers";
import { useCollection } from "react-firebase-hooks/firestore";
import { adminAuthQuery } from "../utils/queryHelpers";
import { createRandomId } from "../utils/helpers";
import { useAuthContext } from "../hooks/useAuth";

const ResetPassword = () => {
  const { authed, setAuthed } = useAuthContext();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [isChanges, setIsChanged] = useState(false);
  const [searchParams] = useSearchParams();
  const [showFirst, setShowFirst] = useState(false);
  const [showSecond, setShowSecond] = useState(false);

  const actionCode = searchParams.get("oobCode");

  const [keySnapshot, loading1, error1] = useCollection(adminAuthQuery(), {
    snapshotListenOptions: {
      includeMetadataChanges: true,
    },
  });

  const onSubmit = async () => {
    if (password.length < 8) {
      setError("Password length should be at least 8");
      return;
    }

    if (!password || !confirmPassword) {
      setError("Please enter password");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords doesn't match");
      return;
    }

    const actionCode = searchParams.get("oobCode");
    const resp = await handleResetPassword({ actionCode, password });
    if (resp.error) {
      setError(resp.error);
    } else {
      let docId = keySnapshot?.docs?.at(0)?.id;
      const docRef = getKeysDoc(
        keySnapshot !== undefined ? docId : "Q8IluqD7Fb1bj5CFhXd7"
      );
      await updateDoc(docRef, {
        password_reset_code: createRandomId(10),
      });
      localStorage.setItem("auth_detail", JSON.stringify({}));
      await signOut(fAuth);
      await setAuthed(false);
      setIsChanged(true);
    }
  };

  if (!actionCode) {
    return <PageNotFound />;
  }
  return (
    <>
      <header
        style={{
          width: "100%",
          // background: "rgb(255,208,115)",
          background:
            "linear-gradient(270deg, rgba(255,208,115,1) 25%, rgba(213,162,62,1) 50%, rgba(179,130,36,1) 75%)",
          height: "50px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <img src={logo} alt="logo" height={40} />
      </header>
      <main className="w-50 m-auto mt-5">
        {isChanges ? (
          <div class="card">
            <div className="card-header text-center">Congratulations</div>
            <div class="card-body text-center">
              Your password has been changed successfully.
            </div>
          </div>
        ) : (
          <>
            <div className="mb-3">
              <div>Enter Password *</div>
              <div class="input-group mb-1">
                <input
                  class="form-control password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  type={showFirst ? "text" : "password"}
                />
                <span
                  class="input-group-text togglePassword"
                  onClick={() => setShowFirst(!showFirst)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill={showFirst ? "goldenRod" : "currentColor"}
                    class="bi bi-eye"
                    viewBox="0 0 16 16"
                  >
                    <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                    <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                  </svg>
                </span>
              </div>
              <span style={{ fontSize: "14px" }}>
                Password should be at least 8 characters long
              </span>
            </div>
            <div className="mb-3">
              <div>Confirm Password *</div>
              <div class="input-group mb-1">
                <input
                  class="form-control password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  // type="password"
                  type={showSecond ? "text" : "password"}
                />
                <span
                  class="input-group-text togglePassword"
                  onClick={() => setShowSecond(!showSecond)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill={showSecond ? "goldenRod" : "currentColor"}
                    class="bi bi-eye"
                    viewBox="0 0 16 16"
                  >
                    <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                    <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                  </svg>
                </span>
              </div>
              <span style={{ fontSize: "14px" }}>
                Password should be at least 8 characters long
              </span>
            </div>
            {error ? (
              <p className="text-danger text-bold text-center">{error}</p>
            ) : null}
            <div>
              <button
                onClick={onSubmit}
                className="btn btn-primary w-100"
                style={{
                  background:
                    "linear-gradient(270deg, rgb(255, 208, 115) 25%, rgb(213, 162, 62) 50%, rgb(179, 130, 36) 75%)",
                  border: 0,
                }}
              >
                Change Password
              </button>
            </div>
          </>
        )}
      </main>
    </>
  );
};

export default ResetPassword;
